import BotaoPessoa from '@/components/botoesMenu/BotaoPessoa';
import BotaoDiagnosticoSocioambiental from '@/components/botoesMenu/BotaoDiagnosticoSocioambiental';
import BotaoTerritorio from '@/components/botoesMenu/BotaoTerritorio';
import BotaoLaudos from '@/components/botoesMenu/BotaoLaudos';
import BotaoHome from '@/components/botoesMenu/BotaoHome';
import BotaoUsuarios from '@/components/botoesMenu/BotaoUsuarios';
import BotaoCompartilhamentoDados from '@/components/botoesMenu/BotaoCompartilhamentoDados';
import BotaoPreAnaliseCredito from '@/components/botoesMenu/BotaoPreAnaliseCredito';
import BotaoOperacoes from '@/components/botoesMenu/BotaoOperacoes';
import BotaoSig from '@/components/botoesMenu/BotaoSig';
import BotaoInteligencia from '@/components/botoesMenu/BotaoInteligencia';
import BotaoInteligenciaCarbono from '@/components/botoesMenu/BotaoInteligenciaCarbono';
import BotaoMonitoramento from '@/components/botoesMenu/BotaoMonitoramento';
import BotaoMonitoramentoSocioambiental from '@/components/botoesMenu/BotaoMonitoramentoSocioambiental';
import BotaoMonitoramentoAgricola from '@/components/botoesMenu/BotaoMonitoramentoAgricola';
import BotaoRastreabilidadeBungeEmpresa from '@/components/botoesMenu/BotaoRastreabilidadeBungeEmpresa';
import BotaoRastreabilidadeBungeSubEmpresa from '@/components/botoesMenu/BotaoRastreabilidadeBungeSubEmpresa';
import BotaoFiscalizacaoOperacoes from '@/components/botoesMenu/BotaoFiscalizacaoOperacoes';
import BotaoRastreabilidadeRaizen from '@/components/botoesMenu/BotaoRastreabilidadeRaizen';
import BotaoDashboardOperacoes from '@/components/botoesMenu/BotaoDashboardOperacoes';
import BotaoGestaoOperacoes from '@/components/botoesMenu/BotaoGestaoOperacoes';
import BotaoInteligenciaTerritorial from '@/components/botoesMenu/BotaoInteligenciaTerritorial';
import BotaoDashboardMonitoramentoOperacoes from '@/components/botoesMenu/BotaoDashboardMonitoramentoOperacoes.vue';
import BotaoOperacoesCdaWa from '@/components/botoesMenu/BotaoOperacoesCdaWa.vue';
import BotaoNoticias from '@/components/botoesMenu/BotaoNoticias.vue';
import UsuarioService from '@/services/UsuarioService';
import BotaoPssc from '@/components/botoesMenu/BotaoPssc.vue';
import BotaoGestaoLotesPssc from '@/components/botoesMenu/BotaoGestaoLotesPssc.vue';
import BotaoDashboardPssc from '@/components/botoesMenu/BotaoDashboardPssc.vue';
import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';
import BotaoCertificacao from '@/components/botoesMenu/BotaoCertificacao.vue';
import BotaoContratoRastreabilidadeCadastrante from '@/components/botoesMenu/BotaoContratoRastreabilidadeCadastrante.vue';
import BotaoContratoRastreabilidadeAprovador from '@/components/botoesMenu/BotaoContratoRastreabilidadeAprovador.vue';
import BotaoRelatorioRastreabilidade from '@/components/botoesMenu/BotaoRelatorioRastreabilidade.vue';
import BotaoOperacoesEmLote from '@/components/botoesMenu/BotaoOperacoesEmLote.vue';

const isAdmin = {
    nome: 'isAdmin',
    permissoes: [
        BotaoHome,
        BotaoSig,
        BotaoPessoa,
        BotaoTerritorio,
        BotaoDiagnosticoSocioambiental,
        BotaoLaudos,
        BotaoUsuarios
    ]
};

const isVegaAdmin = {
    nome: 'isVegaAdmin',
    permissoes: [BotaoNoticias]
};

const isRegular = {
    nome: 'isRegular',
    permissoes: [
        BotaoHome,
        BotaoSig,
        BotaoPessoa,
        BotaoTerritorio,
        BotaoDiagnosticoSocioambiental,
        BotaoLaudos
    ]
};

const isAnalyst = {
    nome: 'isAnalyst',
    permissoes: [BotaoLaudos, BotaoFiscalizacaoOperacoes]
};

const isLaudo = {
    nome: 'isLaudo',
    permissoes: [BotaoHome, BotaoLaudos, BotaoUsuarios]
    // permissoes: [BotaoHome, BotaoLaudos, BotaoUsuarios, BotaoNoticias]
};

const operacaoCadastrante = {
    nome: 'operacaoCadastrante',
    permissoes: [
        BotaoHome,
        BotaoSig,
        BotaoPessoa,
        BotaoTerritorio,
        BotaoDiagnosticoSocioambiental
    ],
    permissoesNaoPertidas: [BotaoLaudos]
};

const operacaoAprovador = {
    nome: 'operacaoAprovador',
    permissoes: [
        BotaoHome,
        BotaoSig,
        BotaoPessoa,
        BotaoTerritorio,
        BotaoDiagnosticoSocioambiental,
        BotaoLaudos
    ]
};

const monitoramentoAccess = {
    nome: 'monitoramentoAccess',
    permissoes: [BotaoMonitoramento],
    perfisPermitido: ['monitoramentoAccess']
};

const monitoramentoSocioambientalAccess = {
    nome: 'monitoramentoSocioambientalAccess',
    permissoes: [BotaoMonitoramentoSocioambiental],
    perfisPermitido: ['monitoramentoSocioambientalAccess']
};

const monitoramentoAgricolaAccess = {
    nome: 'monitoramentoAgricolaAccess',
    permissoes: [BotaoMonitoramentoAgricola],
    perfisPermitido: ['monitoramentoAgricolaAccess']
};

const inteligenciaAccess = {
    nome: 'inteligenciaAccess',
    permissoes: [BotaoInteligencia, BotaoInteligenciaCarbono],
    perfisPermitido: ['inteligenciaAccess']
};

const compartilhamentoDadosAccess = {
    nome: 'compartilhamentoDadosAccess',
    permissoes: [BotaoCompartilhamentoDados],
    perfisPermitido: ['compartilhamentoDadosAccess']
};

const operacaoAccess = {
    nome: 'operacaoAccess',
    permissoes: [BotaoOperacoes, BotaoGestaoOperacoes],
    perfisPermitido: ['operacaoAccess']
};

const dashboardMonitoramentoOperacaoAccess = {
    nome: 'dashboardMonitoramentoOperacaoAccess',
    permissoes: [BotaoDashboardMonitoramentoOperacoes],
    perfisPermitido: ['dashboardMonitoramentoOperacaoAccess']
};

const cadastroOperacaoEmLoteAccess = {
    nome: 'cadastroOperacaoEmLoteAccess',
    permissoes: [BotaoOperacoesEmLote],
    perfisPermitido: ['cadastroOperacaoEmLoteAccess']
};

const operacaoCdaWaAccess = {
    nome: 'operacaoCdaWaAccess',
    permissoes: [BotaoOperacoesCdaWa],
    perfisPermitido: ['operacaoCdaWaAccess']
};

const rastreabilidadeBungeEmpresa = {
    nome: 'rastreabilidadeBungeEmpresa',
    permissoes: [BotaoRastreabilidadeBungeEmpresa]
};

const rastreabilidadeBungeSubEmpresa = {
    nome: 'rastreabilidadeBungeSubEmpresa',
    permissoes: [BotaoRastreabilidadeBungeSubEmpresa]
};

const fiscalizacaoOperacaoAccess = {
    nome: 'fiscalizacaoOperacaoAccess',
    permissoes: [BotaoFiscalizacaoOperacoes],
    perfisPermitido: ['fiscalizacaoOperacaoAccess']
};

const fiscalizacaoOperacaoLeituraAccess = {
    nome: 'fiscalizacaoOperacaoLeituraAccess',
    permissoes: [BotaoFiscalizacaoOperacoes],
    perfisPermitido: ['fiscalizacaoOperacaoLeituraAccess']
};

const dashboardOperacaoAccess = {
    nome: 'dashboardOperacaoAccess',
    permissoes: [BotaoDashboardOperacoes],
    perfisPermitido: ['dashboardOperacaoAccess']
};

const rastreabilidadeRaizen = {
    nome: 'rastreabilidadeRaizen',
    permissoes: [BotaoRastreabilidadeRaizen],
    perfisPermitido: ['rastreabilidadeRaizen']
};

const preAnaliseCreditoAccess = {
    nome: 'preAnaliseCreditoAccess',
    permissoes: [BotaoPreAnaliseCredito],
    perfisPermitido: ['preAnaliseCreditoAccess']
};

const inteligenciaTerritorialAcess = {
    nome: 'inteligenciaTerritorialAcess',
    permissoes: [BotaoInteligenciaTerritorial],
    perfisPermitido: ['inteligenciaTerritorialAcess']
};

const psscAccess = {
    nome: 'psscAccess',
    permissoes: [BotaoPssc]
};

const gestaoLotesPsscAccess = {
    nome: 'gestaoLotesPsscAccess',
    permissoes: [BotaoGestaoLotesPssc]
};

const dashboardPsscAccess = {
    nome: 'dashboardPsscAccess',
    permissoes: [BotaoDashboardPssc]
};

const certificacaoAccess = {
    nome: 'certificacaoAccess',
    permissoes: [BotaoCertificacao]
};

const relatorioRastreabilidadeAccess = {
    nome: 'relatorioRastreabilidadeAccess',
    permissoes: [BotaoRelatorioRastreabilidade]
};

const pyAccess = {
    nome: 'pyAccess',
    permissoes: [
        BotaoHome,
        BotaoTerritorio,
        BotaoPessoa,
        BotaoSig,
        BotaoDiagnosticoSocioambiental
    ]
};

const pyAccessAdmin = {
    nome: 'pyAccessAdmin',
    permissoes: [
        BotaoHome,
        BotaoTerritorio,
        BotaoPessoa,
        BotaoSig,
        BotaoDiagnosticoSocioambiental,
        BotaoUsuarios
    ]
};

const arAccess = {
    nome: 'arAccess',
    permissoes: [
        BotaoHome,
        BotaoTerritorio,
        BotaoPessoa,
        BotaoSig,
        BotaoDiagnosticoSocioambiental
    ]
};

const arAccessAdmin = {
    nome: 'arAccessAdmin',
    permissoes: [
        BotaoHome,
        BotaoTerritorio,
        BotaoPessoa,
        BotaoSig,
        BotaoDiagnosticoSocioambiental,
        BotaoUsuarios
    ]
};

const perfilPermissao = [
    isAdmin,
    isVegaAdmin,
    isRegular,
    isAnalyst,
    isLaudo,
    operacaoCadastrante,
    operacaoAprovador,
    monitoramentoAccess,
    monitoramentoSocioambientalAccess,
    monitoramentoAgricolaAccess,
    inteligenciaAccess,
    compartilhamentoDadosAccess,
    operacaoAccess,
    cadastroOperacaoEmLoteAccess,
    dashboardMonitoramentoOperacaoAccess,
    rastreabilidadeBungeEmpresa,
    rastreabilidadeBungeSubEmpresa,
    fiscalizacaoOperacaoAccess,
    fiscalizacaoOperacaoLeituraAccess,
    dashboardOperacaoAccess,
    rastreabilidadeRaizen,
    preAnaliseCreditoAccess,
    inteligenciaTerritorialAcess,
    operacaoCdaWaAccess,
    psscAccess,
    gestaoLotesPsscAccess,
    dashboardPsscAccess,
    certificacaoAccess
];

const buscarPermissoesMenuFeature = async dadosUsuario => {
    let botoes = [];
        const usuario = JSON.parse(JSON.stringify(dadosUsuario));
        const response = await UsuarioService.buscaPermissaoUsuario(
            usuario.idGrupo
        );
        const data = response.data;
        data.forEach(response => {
            const menuLinkExterno = {
                componentOptions: {
                    actions: [
                        [
                            {
                                name: response.nome,
                                iconClass: response.icone,
                                route: response.url
                            }
                        ]
                    ]
                }
            };
            if (usuario.paisGrupo !== AmbientesEmpresas.PARAGUAY) {
                isRegular.permissoes.push(menuLinkExterno);
            }
        });

        if (usuario.paisGrupo === AmbientesEmpresas.PARAGUAY) {
            botoes = [];
            if (usuario.isAdmin === true) {
                pyAccessAdmin.permissoes.forEach((componente) => {
                    if (!botoes.includes(componente)) {
                        botoes.push(componente);
                    }
                });
            } else {
                pyAccess.permissoes.forEach((componente) => {
                    if (!botoes.includes(componente)) {
                        botoes.push(componente);
                    }
                });
            }

            if (usuario.contratoRastreabilidadeAccess === true) {
                if (usuario.authorities.find(item => item.authority === 'ROLE_FEATURE_CONTRATO_RASTREABILIDADE_CADASTRANTE')) {
                    botoes.push(BotaoContratoRastreabilidadeCadastrante);
                }
                if (usuario.authorities.find(item => item.authority === 'ROLE_FEATURE_CONTRATO_RASTREABILIDADE_APROVADOR')) {
                    botoes.push(BotaoContratoRastreabilidadeAprovador);
                }
            }

            if (usuario.relatorioRastreabilidadeAccess === true) {
                relatorioRastreabilidadeAccess.permissoes.forEach(componente => {
                    if (!botoes.includes(componente)) {
                        botoes.push(componente);
                    }
                });
            }

            [monitoramentoSocioambientalAccess, monitoramentoAgricolaAccess].forEach((pp) => {
                if (usuario[pp.nome]) {
                    pp.permissoes.forEach((componente) => {
                        if (!botoes.find((b) => b === componente)) {
                            botoes.push(componente);
                        }
                    });
                }
            });
        } else if (usuario.paisGrupo === AmbientesEmpresas.ARGENTINA) {
            botoes = [];
            if (usuario.isAdmin === true) {
                arAccessAdmin.permissoes.forEach((componente) => {
                    if (!botoes.includes(componente)) {
                        botoes.push(componente);
                    }
                });
            } else {
                arAccess.permissoes.forEach((componente) => {
                    if (!botoes.includes(componente)) {
                        botoes.push(componente);
                    }
                });
            }

            [monitoramentoSocioambientalAccess].forEach((pp) => {
                if (usuario[pp.nome]) {
                    pp.permissoes.forEach((componente) => {
                        if (!botoes.find((b) => b === componente)) {
                            botoes.push(componente);
                        }
                    });
                }
            });
        } else {
            botoes = [];
            // Adiciona os botões conforme as configurações
            perfilPermissao.forEach(pp => {
                if (usuario[pp.nome]) {
                    pp.permissoes.forEach(componente => {
                        if (!botoes.find(b => b === componente)) {
                            if (pp.perfisPermitido) {
                                let temPermissao = false;
                                pp.perfisPermitido.forEach(pnp => {
                                    if (usuario[pnp]) {
                                        temPermissao = true;
                                    }
                                });
                                if (temPermissao) {
                                    botoes.push(componente);
                                }
                            } else {
                                botoes.push(componente);
                            }
                        }
                    });
                }
            });

            // Remove os botões conforme as configurações
            perfilPermissao.forEach(pp => {
                if (usuario[pp.nome]) {
                    if (pp.permissoesNaoPertidas) {
                        pp.permissoesNaoPertidas.forEach(componente => {
                            botoes = botoes.filter(b => b.name !== componente.name);
                        });
                    }
                }
            });

            // Remove os botões que constam em submenus
            botoes.forEach(b => {
                if (b.componentOptions.actions[0][0].submenus) {
                    b.componentOptions.actions[0][0].submenus =
                        b.componentOptions.actions[0][0].submenus.filter(sm =>
                            botoes.includes(sm)
                        );
                    b.componentOptions.actions[0][0].submenus.forEach(sm => {
                        botoes = botoes.filter(b => b.name !== sm.name);
                    });
                }
            });
        }
    return botoes;
};

export default {
    buscarPermissoesMenuFeature
};
